import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { FetchMembersResponse } from 'services/affiliates'

export const initialState: FetchMembersResponse = []

export const affiliateMembersSlice = createSlice({
  name: 'affiliateMembers',
  initialState,
  reducers: {
    setAffiliateMembers: (
      state,
      action: PayloadAction<FetchMembersResponse>,
    ) => {
      return action.payload
    },
    updateAffiliateMember: (
      state,
      action: PayloadAction<{
        userId: number
        order?: number
        isPublic?: boolean
      }>,
    ) => {
      state[action.payload.userId] = {
        ...state[action.payload.userId],
        ...action.payload,
      }
      return state
    },
  },
})

export const { setAffiliateMembers, updateAffiliateMember } =
  affiliateMembersSlice.actions
export default affiliateMembersSlice.reducer
